import http from '../utils/http';
import i18n from '@/main';

const baseUrl = '/representantes';

export default {
  findTipoArquivos() {
        return http.get({
            url: baseUrl + '/tipo-arquivos',
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoGeometria')
        });
    }
};
